export default {
      id: "menu__history_fill-usage",
      viewBox: "0 0 144 105",
      url: __webpack_public_path__ + "img/icons.svg#menu__history_fill",
      toString: function () {
        return this.url;
      }
    }